export default [
  {
    answer: 0,
    questions: [
      'Gu_7Y8-wv надежный пароль.',
      'Gu_7Y8-wv ненадежный пароль.',
    ],
  },
  {
    answer: 1,
    questions: [
      'Можно использовать любые Wi-Fi сети и без пароля, они все равно безопасные!',
      'Неизвестные Wi-Fi сети без пароля лучше не использовать — через них злоумышленники могут украсть твои данные.',
    ],
  },
  {
    answer: 1,
    questions: [
      'Если столкнулся с опасностью в сети и не знаешь, что делать — главное, не рассказывай родителям, вдруг получится самому справиться с ситуацией!',
      'Если столкнулся с опасностью в сети, расскажи обо всём родителям и  обратись за помощью к профессионалам!',
    ],
  },
]
